import { Component, inject } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { JumpstartComponentsWkIconsModule, JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "wk-add-edit",
    templateUrl: "add-edit.component.html",
    styleUrl: "./add-edit.component.scss",
    host: {
        class: "wk-add-edit",
    },
    imports: [JumpstartComponentsWkIconsModule, JumpstartComponentsModule, FormsModule, TranslatePipe],
})
export class AddEditComponent {
    bsModalRef = inject(BsModalRef);

    data: any;
    initialColumn: any;
    title: string;
    callback: (column: any) => void;

    constructor() {}

    submitForm() {
        if (this.data.Name["en-CA"].trim() !== "" && this.data.Name["fr-CA"].trim() !== "") {
            this.callback(this.data);
            this.bsModalRef.hide();
        }
    }
}
